import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Input from './formInputs/Input';

import {
  needsNumber,
  needsUppercase,
  needsLowercase,
  needsSpecialChar,
  passMinLength,
  noFirstLastName
} from '~APP_UTIL/formValidations';
import { TranslatedCopy } from '../intl/TranslatedCopy';

const checkedIcon = <i data-desc='passwordCheck__checked' className='g72-check text-color-success' />;

const PasswordCheck = props => {
  const {
    meta: { pristine },
    input: { value },
    firstName,
    lastName,
    profileRoute
  } = props;

  return (
    <>
      <Input {...props} />
      <div className='body-4 mb5-sm ta-sm-l'>
        <p>
          <TranslatedCopy id='userManagement.invite.passwordMustContain' />:
        </p>
        <ul className='passwordChecklist'>
          <li data-desc='passwordCheck__min_Length'>
            {!pristine && !passMinLength(value) && checkedIcon} <TranslatedCopy id='password.chars' />
          </li>
          <li data-desc='passwordCheck__uppercase'>
            {!pristine && !needsUppercase(value) && checkedIcon} <TranslatedCopy id='password.uppercase' />
          </li>
          <li data-desc='passwordCheck__lowercase'>
            {!pristine && !needsLowercase(value) && checkedIcon} <TranslatedCopy id='password.lowercase' />
          </li>
          <li data-desc='passwordCheck__number'>
            {!pristine && !needsNumber(value) && checkedIcon} <TranslatedCopy id='password.number' />
          </li>
          <li data-desc='passwordCheck__special_char'>
            {!pristine && !needsSpecialChar(value) && checkedIcon} <TranslatedCopy id='password.special' />
          </li>
          {profileRoute && (
            <li data-desc='passwordCheck__first_last_name'>
              {!pristine && !noFirstLastName(firstName, lastName)(value) && checkedIcon}
              <TranslatedCopy id='password.first.last' />
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

PasswordCheck.propTypes = {
  meta: PropTypes.shape({
    pristine: PropTypes.bool.isRequired
  }).isRequired,
  input: PropTypes.shape({
    value: PropTypes.string.isRequired
  }).isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profileRoute: PropTypes.bool
};

PasswordCheck.defaultProps = {
  firstName: '',
  lastName: '',
  profileRoute: true
};

export default PasswordCheck;
